// extracted by mini-css-extract-plugin
export var closeButton = "_5w-0";